import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import { AffectedResourceDto } from "../../../../../customer-experience/src/lib/ShiOneClient";
import { getResourceItemKey } from "../../../../../customer-experience/src/v2/src/features/recommendations-feature/utils/recommendationUtils";

interface RecommendationListItemAdditionalContentProps {
  displayedResources: AffectedResourceDto[];
  totalResources: number;
}
export const RecommendationListItemAdditionalContent = ({
  displayedResources,
  totalResources,
}: RecommendationListItemAdditionalContentProps) => {
  const theme = useTheme();
  const maxDisplayedResources = 5;
  if (totalResources === 0) {
    return null;
  }

  return (
    <Box sx={{ mt: 1, ml: 2 }}>
      <Typography
        variant="caption"
        sx={{
          color: theme.palette.text.secondary,
          fontWeight: "bold",
        }}
      >
        Affected Resources:
      </Typography>
      <Box sx={{ mt: 0.5 }}>
        {displayedResources.map((resource, position) => {
          const itemKey = getResourceItemKey(resource.resourceId, position);
          return (
            <Typography
              key={itemKey}
              variant="caption"
              sx={{
                display: "block",
                color: theme.palette.text.secondary,
                ml: 1,
                lineHeight: 1.4,
              }}
            >
              • {resource.resourceName || "Unnamed"}
              {resource.resourceType ? ` (${resource.resourceType})` : ""}
            </Typography>
          );
        })}
        {totalResources > maxDisplayedResources && (
          <Typography
            variant="caption"
            sx={{
              display: "block",
              color: theme.palette.text.secondary,
              ml: 1,
              fontStyle: "italic",
              lineHeight: 1.4,
            }}
          >
            ... and {totalResources - maxDisplayedResources} more
          </Typography>
        )}
      </Box>
    </Box>
  );
};
